<script setup lang="ts">
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'HeaderHelpers',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  {
    id: 'helpers',
    text: 'Helpers',
    to: AppRoute.Helpers,
    disabled: true,
  },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
